import { FC, useState } from 'react';

import { IDictionaryItem } from 'api/types';
import { useDisclosure } from 'hooks';
import FilterButton from 'portfolio3/components/common/buttons/FilterButton';
import { MobileActionsDrawer } from 'portfolio3/components/drawers';
import { RadioGroupControl, RadioGroupController } from 'portfolio3/components/forms/RadioGroupControl';

interface IPersonalDiagnosticGeneralMobileFilterProps {
  currentLearningYear: IDictionaryItem | null;
  learningYearOptions: IDictionaryItem[];
  setCurrentLearningYear: (value: IDictionaryItem | null) => void;
  getLearningYearLabel: (value: IDictionaryItem) => string;
}

const PersonalDiagnosticGeneralMobileFilter: FC<IPersonalDiagnosticGeneralMobileFilterProps> = ({
  currentLearningYear,
  learningYearOptions,
  setCurrentLearningYear,
  getLearningYearLabel,
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [tempLearningYear, setTempLearningYear] = useState<IDictionaryItem | null>(currentLearningYear);

  const handleOpen = () => {
    setTempLearningYear(currentLearningYear);
    onOpen();
  };

  const resetFilters = () => {
    if (learningYearOptions.length > 0) {
      setTempLearningYear(learningYearOptions[0]);
    }
  };

  const applyFilters = () => {
    setCurrentLearningYear(tempLearningYear);
    onClose();
  };

  const tempLearningYearController: RadioGroupController = {
    handleChange(code) {
      const option = learningYearOptions.find((option) => option.code === code);
      setTempLearningYear(option ?? currentLearningYear);
    },
  };

  const isFilterApplied = currentLearningYear?.code !== learningYearOptions[0]?.code;
  const isResetDisabled = tempLearningYear?.code === learningYearOptions[0]?.code;

  return (
    <>
      <FilterButton onClick={handleOpen} withIndicator={isFilterApplied} />

      <MobileActionsDrawer
        open={isOpen}
        onClose={onClose}
        title="Фильтр индивидуальные диагностики"
        isResetDisabled={isResetDisabled}
        onReset={resetFilters}
        onApply={applyFilters}
      >
        <RadioGroupControl
          isMobile
          label="Учебный год"
          value={tempLearningYear?.code}
          options={learningYearOptions}
          controller={tempLearningYearController}
          renderLabel={getLearningYearLabel}
        />
      </MobileActionsDrawer>
    </>
  );
};

export default PersonalDiagnosticGeneralMobileFilter;
